import { AngularFireAuth } from '@angular/fire/auth';
import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.page.html',
  styleUrls: ['./delete-user.page.scss']
})
export class DeleteUserPage implements OnInit {

  en_deleteAccTitle = 'Delete Account';
  en_confirmationSubtitle = 'Please, confirm that you are ';
  en_deleteButton = 'Delete';

  sp_deleteAccTitle = 'Eliminar Cuenta';
  sp_confirmationSubtitle = 'Por favor, confirma que eres ';
  sp_deleteButton = 'Eliminar';

  name;
  language: string;

  constructor(private _viewCtrl: ModalController, private _auth: AngularFireAuth,
    private _params: NavParams) {
  }

  async ngOnInit() {
    this.language = this._params.get('language');
    this.name = this._auth.auth.currentUser.displayName;
    this.didEnter();
  }

  didEnter() {
    const text = document.getElementsByClassName('to_hide_text') as HTMLCollectionOf<HTMLElement>;
    for (let i = 0; i < text.length; i++) { text[i].classList.add('anim'); }
  }

  goBack() {
    this._viewCtrl.dismiss();
  }

}

